var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.525,
    height: 16.161,
    viewBox: "0 0 43.525 16.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_small",
    "data-name": "Arrow small",
    transform: "translate(-535.962 -321.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34568",
    "data-name": "Path 34568",
    d: "M10572.635-9253.792s11.039,11.8,23.094,10.15,17.392-15.317,17.392-15.317",
    transform: "translate(-10034.099 9581)",
    fill: "none",
    stroke: "#f60",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M0,0,2.28,2.28,4.56,0",
    transform: "matrix(-0.719, 0.695, -0.695, -0.719, 541.682, 327.1)",
    fill: "none",
    stroke: "#f60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallarrow);
export default __webpack_public_path__ + "static/media/smallarrow.bf45c2fe23b9a6e08d765222b4b0a153.svg";
export { ForwardRef as ReactComponent };